import { ASK_AI_ADMIN_ROOT_PATH } from './constants';

export const getAskAiAdminPath = (path: string) => `${ASK_AI_ADMIN_ROOT_PATH}/${path}`;
